export default "__VITE_ASSET__DW75Aim1__"